import { getRootWindow } from '../utils/window';

const win = getRootWindow();
win.VERSIONS = win.VERSIONS || {};
win.VERSIONS[__INTERNAL__MODULE_NAME] = __INTERNAL__MODULE_VERSION;
